import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from '../Message/Message';
import { jsx as _jsx } from "react/jsx-runtime";
export const TvGuideMessage = ({
  isLoading,
  isError,
  isEmpty
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: !isLoading && (isError || isEmpty) && /*#__PURE__*/_jsx(Message, {
      text: isError ? t('tvGuide.errorLoadingData') : t('tvGuide.noDataForDate'),
      type: isError ? 'Error' : 'Info'
    })
  });
};